import { Col, Layout, Row, Select, Space, Typography, message } from "antd";
import { SelectValue } from "antd/es/select";
import { t } from "i18next";
import { FilterFunc } from "rc-select/lib/Select";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ArrowLeftIconComponent from "../../../components/ArrowLeftIconComponent";
import AuthButtonComponent from "../../../components/AuthButtonCompnent";
import AuthInputComponent from "../../../components/AuthInputComponent";
import AuthOrDividerComponent from "../../../components/AuthOrDividerComponent";
import { IBillingAddressRequest, initialBillingAddressRequest } from "../../../helpers/requests";
import { IUserInfos } from "../../../helpers/types";
import useFetchUserInfos from "../../../hooks/userHooks/useFetchUserInfos";
import { updateBillingAddressInfos } from "../../../redux/users/usersSlice";
import { userService } from "../../../services";
import { COUNTRIES_OPTIONS } from "../../../utls/CountryUtil";
import "./index.less";

interface OptionItem {
  value: SelectValue;
  label: string;
}

const CreatorBillingAddress = () => {
  const dispatch = useDispatch();
  const { currentUser: user } = useFetchUserInfos(true);
  const [localBillingAddress, setLocalBillingAddress] = useState<IBillingAddressRequest>(initialBillingAddressRequest);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const countries: OptionItem[] = useMemo(() => COUNTRIES_OPTIONS, []);

  useEffect(() => {
    if (!user?.infos?.privateInfos?.billingAddress) return;
    setLocalBillingAddress(user?.infos?.privateInfos?.billingAddress);
  }, [user?.infos]);

  useEffect(() => {
    if (dropdownOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [dropdownOpen]);

  const updateBillingAddress = () => {
    //TODO : service needs improvement and usinf the dispatch
    if (!user?.infos) return;
    userService
      .updateBillingAddressInfos(localBillingAddress)
      .then((user: IUserInfos) => {
        message.success(t("billing-information-has-been-updated"));
        dispatch(updateBillingAddressInfos(user));
        navigate(-1);
      })
      .catch((error) => message.error(t(error)));
  };

  const handleBillingChange = (e: { target: { name: string; value: string } }) => {
    const { name, value } = e.target;
    setLocalBillingAddress((prev) => ({ ...prev, [name]: value }));
  };

  const filterOption: FilterFunc<OptionItem> | undefined = (inputValue: string, option?: OptionItem) => {
    return (option?.label.toLowerCase() ?? "").indexOf(inputValue.toLowerCase()) !== -1;
  };

  const handleDropdownVisibleChange = (open: boolean) => {
    setDropdownOpen(open);
  };

  const handleDisabled = () => {
    if (!localBillingAddress?.address) return true;
    if (!localBillingAddress?.city) return true;
    if (!localBillingAddress?.companyName) return true;
    if (!localBillingAddress?.country) return true;
    if (!localBillingAddress?.postalCode) return true;
    if (!localBillingAddress?.vatNumber) return true;
    return false;
  };

  return (
    <>
      <Layout.Content className="content creatorPersonalInformationContentWrapper gradient-background">
        <Row className="relative justify-content-center header-title-container-70">
          <ArrowLeftIconComponent left={0} top={12} />
          <Typography.Text className="header-title-black-35">{t("billing")}</Typography.Text>
        </Row>
        <Col className="mt-20">
          <Row>
            <Space className="w-full" direction="vertical">
              <Row className="justify-content-center"></Row>
              <Row>
                <AuthInputComponent
                  label={t("company-name")}
                  placeholder={t("company-name")!}
                  type="text"
                  name="companyName"
                  value={localBillingAddress?.companyName || ""}
                  handleChange={handleBillingChange}
                />
              </Row>
              <Row>
                <AuthInputComponent
                  label={t("address")}
                  placeholder={t("address")!}
                  type="text"
                  name="address"
                  value={localBillingAddress?.address || ""}
                  handleChange={handleBillingChange}
                />
              </Row>
              <Row gutter={7}>
                <Col span={12}>
                  <AuthInputComponent
                    label={t("city")}
                    placeholder={t("city")!}
                    type="text"
                    name="city"
                    value={localBillingAddress?.city || ""}
                    handleChange={handleBillingChange}
                  />
                </Col>
                <Col span={12}>
                  <AuthInputComponent
                    label={t("postal-code")!}
                    placeholder={t("postal-code")!}
                    type="text"
                    name="postalCode"
                    value={localBillingAddress?.postalCode || ""}
                    handleChange={handleBillingChange}
                  />
                </Col>
              </Row>
              <Row>
                <Space className="w-full gap-6" direction="vertical">
                  <Typography.Text className="authInputLabel">{t("country")}</Typography.Text>
                  <Select
                    showSearch
                    placeholder={t("country")!}
                    className="select-billing dark"
                    options={countries}
                    filterOption={filterOption}
                    value={localBillingAddress?.country}
                    onSelect={(country: any) => {
                      setLocalBillingAddress((prev) => ({ ...prev, country }));
                    }}
                    autoFocus={false}
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={{ position: "fixed", zIndex: 1000 }}
                    onDropdownVisibleChange={handleDropdownVisibleChange}
                    onFocus={(e) => e.preventDefault()}
                    onClick={(e) => e.preventDefault()}
                  />
                </Space>
              </Row>
              <Row>
                <AuthInputComponent
                  label={t("vat-number")}
                  placeholder={t("vat-number")!}
                  type="text"
                  name="vatNumber"
                  value={localBillingAddress?.vatNumber || ""}
                  handleChange={handleBillingChange}
                />
              </Row>
              <Row className="mt-49">
                <AuthButtonComponent disabled={handleDisabled()} label={t("continue-label")} onClick={updateBillingAddress} />
              </Row>
            </Space>
          </Row>
          <Row>
            <AuthOrDividerComponent />
          </Row>
        </Col>
      </Layout.Content>
    </>
  );
};

export default CreatorBillingAddress;
